import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FILEVAULT_API_URL } from '@filevault/components';

export interface CreateFileVaultPartRequest {
  partNumber: string;
  name: string;
  description?: string;
  unitOfMeasure?: string;
  attributes?: Record<string, unknown>;
}

export interface BomDocumentLink {
  partNumber: string;
  documentNumber: string;
  documentVersion: string;
  documentPart: string;
  documentType: string;
  title?: string;
  description?: string;
  bomItemNumber: string;
  bomItemCategory?: string;
  createdBy: string;
}

export interface LinkBomDocumentsRequest {
  partNumber: string;
  documents: BomDocumentLink[];
}

@Injectable({
  providedIn: 'root'
})
export class FileVaultApiService {
  constructor(
    private http: HttpClient,
    @Inject(FILEVAULT_API_URL) private baseUrl: string
  ) {}

  createPart(request: CreateFileVaultPartRequest): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/Parts`, request);
  }

  linkBomDocuments(request: LinkBomDocumentsRequest): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/Documents/link-bom-documents`, request);
  }

  getPartIdByPartNumber(partNumber: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/Parts/by-number/${partNumber}`);
  }

  /**
   * Check if a part (by material number) has any locked (checked-out) files.
   * Returns true if at least one file is currently locked.
   */
  isPartLocked(materialNumber: number): Observable<boolean> {
    const params = new HttpParams()
      .set('targetId', materialNumber.toString())
      .set('isLocked', 'true')
      .set('pageSize', '1');
    return this.http.get<any>(`${this.baseUrl}/Files/search`, { params }).pipe(
      map(result => (result?.totalCount ?? result?.items?.length ?? 0) > 0)
    );
  }
}
